import { TimeFilterType } from 'generated-graphql/types';
import { SourcingExternalSearchFilterFormData } from 'modules/sourcing-external/forms/schemas/sourcingExternalSearchFilterSchema';
import { SOURCING_EXTERNAL_INDUSTRIES } from 'modules/sourcing-external/constants/sourcingExternalIndustries';
import { SOURCING_EXTERNAL_YEARS_OF_EXPERIENCE } from 'modules/sourcing-external/constants/sourcingExternalYearsOfExperience';
import { SOURCING_EXTERNAL_YEARS_IN_CURRENT_ROLE } from 'modules/sourcing-external/constants/sourcingExternalYearsInCurrentRole';
import { SOURCING_EXTERNAL_COMPANY_SIZES } from 'modules/sourcing-external/constants/sourcingExternalCompanySizes';
import { SearchPeopleQueryInputWithoutCandidateBatchId } from 'modules/sourcing-external/stores';
import { GenerateSearchPeopleQueryFieldsMutation } from 'generated-graphql/graphql';

export const mapSearchGeneratePayloadToFilters = (
  payload: GenerateSearchPeopleQueryFieldsMutation['generateSearchPeopleQueryFields']
): SearchPeopleQueryInputWithoutCandidateBatchId => {
  return {
    job_title: payload.job_title || [],
    current_titles_only:
      payload.current_titles_only === null ? true : payload.current_titles_only,
    include_related_job_titles:
      payload.include_related_job_titles === null
        ? false
        : payload.include_related_job_titles,
    exclude_job_titles: payload.exclude_job_titles || undefined,
    company: payload.company || [],
    company_filter: payload.company_filter || TimeFilterType.Current,
    exclude_companies: payload.exclude_companies || undefined,
    keyword: payload.keyword || '',
    location: payload.location || [],
    skills: payload.skills || [],
    industry: payload.industry || [],
    years_of_experience: payload.years_of_experience || [],
    years_in_current_role: payload.years_in_current_role || [],
    company_size: payload.company_size || [],
    education: payload.education || [],
    name: payload.name || ''
  };
};

export const mapFiltersToSearchPeoplePayload = (
  filters: SourcingExternalSearchFilterFormData
): SearchPeopleQueryInputWithoutCandidateBatchId => {
  return {
    job_title: filters.jobTitle?.filter(Boolean) as string[],
    current_titles_only: filters.currentTitlesOnly,
    include_related_job_titles: filters.includeRelatedJobTitles,
    exclude_job_titles: filters.excludeJobTitles
      ? (filters.jobTitleExclusions?.filter(Boolean) as string[])
      : undefined,
    company: filters.company?.filter(Boolean) as string[],
    company_filter: filters.companyFilter as TimeFilterType,
    exclude_companies: filters.excludeCompanies
      ? (filters.companyExclusions?.filter(Boolean) as string[])
      : undefined,
    keyword: filters.keyword,
    location: filters.location?.filter(Boolean) as string[],
    skills: filters.skills?.filter(Boolean) as string[],
    industry: filters.industry?.filter(Boolean) as string[],
    years_of_experience: filters.yearsOfExperience?.filter(Boolean) as string[],
    years_in_current_role: filters.yearsInCurrentRole?.filter(
      Boolean
    ) as string[],
    company_size: filters.companySize?.filter(Boolean) as string[],
    education: filters.education?.filter(Boolean) as string[],
    name: filters.name
  };
};

export const mapSearchPeoplePayloadToFilters = (
  payload: SearchPeopleQueryInputWithoutCandidateBatchId
): SourcingExternalSearchFilterFormData => {
  return {
    jobTitle: payload.job_title?.filter(
      (title) => title !== undefined
    ) as string[],
    currentTitlesOnly: payload.current_titles_only as boolean,
    includeRelatedJobTitles: payload.include_related_job_titles as boolean,
    excludeJobTitles: !!payload.exclude_job_titles?.length,
    jobTitleExclusions:
      (payload.exclude_job_titles?.filter(Boolean) as string[]) || [],
    company: payload.company?.filter(Boolean) as string[],
    companyFilter: payload.company_filter as TimeFilterType,
    excludeCompanies: !!payload.exclude_companies?.length,
    companyExclusions:
      (payload.exclude_companies?.filter(Boolean) as string[]) || [],
    keyword: payload.keyword as string,
    location: payload.location?.filter(Boolean) as string[],
    skills: payload.skills?.filter(Boolean) as string[],
    industry: payload.industry?.filter(
      Boolean
    ) as (typeof SOURCING_EXTERNAL_INDUSTRIES)[number][],
    yearsOfExperience: payload.years_of_experience?.filter(
      (experience) => experience !== undefined
    ) as (typeof SOURCING_EXTERNAL_YEARS_OF_EXPERIENCE)[number]['value'][],
    yearsInCurrentRole: payload.years_in_current_role?.filter(
      (experience) => experience !== undefined
    ) as (typeof SOURCING_EXTERNAL_YEARS_IN_CURRENT_ROLE)[number]['value'][],
    companySize: payload.company_size?.filter(
      (size) => size !== undefined
    ) as (typeof SOURCING_EXTERNAL_COMPANY_SIZES)[number]['value'][],
    education: payload.education?.filter(
      (education) => education !== undefined
    ) as string[],
    name: payload.name as string
  };
};
